// Server-side session state frames on the room socket (BE-7):
//   {"type":"session.state","appointment":<id>,"state":{...}}
// appointmentContext forwards them as a window event; SessionStateProvider listens.
export const SESSION_STATE_EVENT = 'ibis:session-state';

// Accepts the raw ws frame in any of the shapes the consumer may use and returns {appointment, state} or null.
export const extractSessionStateMessage = (data) => {
  if (!data || typeof data !== 'object') return null;
  if (data.type === 'session.state') return data;
  if (data.message && typeof data.message === 'object' && data.message.type === 'session.state') return data.message;
  return null;
};
